import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Row, Col, Accordion, Card, Button } from "react-bootstrap";
import ChangeMobileNumberPopup from "../ChangeMobileNumberPopup";
import http from "../../api/http-request";
import Alert from "../common/Alert";
import ChangeLanguagePopup from "../ChangeLanguagePopup";
import Checkbox from "../common/Checkbox";
import {
  pageNotFound
} from "../../utils/common";
import { setCookie } from "../../utils/cookies";
import i18n from "../../i18n";

class Preferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleCommunications: true,
      alertStatus: "",
      alertText: "",
      preferences: {
        preferredLanguage: "en_US",
        bos: {
          dueDate: {
            email: false,
            sms: false
          },
          news: {
            email: false,
            sms: false
          },
          covid19: {
            email: false,
            sms: false
          },
          resourceNotification: {
            email: false,
            sms: false
          }
        }
      },
      changeLanguagePopup: false,
      addNumberPopup: false,
      showAppPreferences: false,
      hideSection: true
    };
  }

  componentDidMount() {
    this.getPreferences();
  }

  getAPIHeaders = () => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    return {
      Authorization: `${bearer}${dataStoreToken}`,
    };
  };

  getPreferenceByUserRoles = (userPreferences) => {
    const { userId } = this.props;
    http(
      {
        url: `managed/user/${userId}/roles?&_queryFilter=true&_fields=_refResourceId`,
        method: "GET"
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.resultCount >= 0) {
        const { preferences } = this.state;
        const {
          data: { result }
        } = res;
        const availableRoles = result.map((role) => role._refResourceId);
        const preferredLanguage = userPreferences
          ? userPreferences.preferredLanguage
          : "";
        const newPreference = availableRoles.reduce(
          (prefObj, roleName) => {
            let businessPreferences = [];
            if (preferences[roleName]) {
              businessPreferences = Object.keys(
                preferences[roleName] 
              ).reduce((acc, notificationType) => {
                if (userPreferences[roleName][notificationType]) {
                  return {
                    ...acc,
                    [roleName]: {
                      ...acc[roleName],
                      [notificationType]:
                        userPreferences[roleName][notificationType]
                    }
                  };
                }
                return {
                  ...acc,
                  [roleName]: {
                    ...acc[roleName],
                    [notificationType]: preferences[roleName][notificationType]
                  }
                };
              }, {});
            }
            return {
              ...prefObj,
              ...businessPreferences
            };
          },
          {
            preferredLanguage: this.getDefaultPreferredLanguage(
              preferredLanguage
            )
          }
        );
        this.setState({ preferences: newPreference, showAppPreferences: true });
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
    });
  };

  getDefaultPreferredLanguage = (preferredLanguage) => {
    if (preferredLanguage) {
      if (preferredLanguage === "" || preferredLanguage === "en") {
        return "en_US";
      }
      return preferredLanguage;
    }
    return "en_US";
  };

  getPreferences = () => {
    const { userId } = this.props;
    
    http(
      {
        url: `managed/user/${userId}?&_fields=preferences`,
        method: "GET"
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id) {
        const { preferences } = res.data;
        this.getPreferenceByUserRoles(preferences);
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
    });
  };

  changePreference = (business, notificationType, notificationChannel) => {
    this.setState((prevState) => ({
      ...prevState,
      preferences: {
        ...prevState.preferences,
        [business]: {
          ...prevState.preferences[business],
          [notificationType]: {
            ...prevState.preferences[business][notificationType],
            [notificationChannel]: !prevState.preferences[business][
              notificationType
            ][notificationChannel]
          }
        }
      }
    }));
  };

  changeAllPreference = (business, notificationChannel, isChecked) => {
    this.setState((prevState) => {
      const newBusinessStructure = prevState.preferences[business];
      Object.keys(prevState.preferences[business]).forEach((type) => {
        newBusinessStructure[type][notificationChannel] = isChecked;
      });
      return {
        ...prevState,
        preferences: {
          ...prevState.preferences,
          [business]: newBusinessStructure
        }
      };
    });
  };

  isAllPreferenceSelected = (business, notificationChannel) => {
    const { preferences } = this.state;
    if (Object.keys(preferences[business]).length === 0) {
      return false;
    }
    return Object.keys(preferences[business]).every(
      (type) => preferences[business][type][notificationChannel]
    );
  };

  toggleLanguagePopup = (show) => {
    this.setState({
      changeLanguagePopup: show
    });
  };

  toggleAddNumberPopup = (show) => {
    this.setState({
      addNumberPopup: show
    });
  };

  onLanguageChange = (preferredLanguage) => {
    this.setState(
      (prevState) => ({
        preferences: {
          ...prevState.preferences,
          preferredLanguage
        }
      }),
      () => this.updateLanguage()
    );
  };

  updateLanguage = () => {
    const {
      preferences: { preferredLanguage }
    } = this.state;
    i18n.changeLanguage(preferredLanguage);
    setCookie("ctsessionlanguage", preferredLanguage);
    let { userId } = this.props;
    const payload = [
      {
        operation: "add",
        field: "/preferences/preferredLanguage",
        value: preferredLanguage === "en_US" ? "en" : preferredLanguage
      }
    ];
    http(
      {
        url: `managed/user/${userId}`,
        method: "PATCH",
        data: payload
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      let alertText = "";
      let alertStatus = "";
      if (res && res.status === 200 && res.data && res.data._id === userId) {
        alertText = "pages.changePreferredLang.langPreferenceChangeSuccessMsg";
        alertStatus = "success";
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        alertText = "pages.changePreferredLang.langPreferenceChangeErrorMsg";
        alertStatus = "error";
      }
      this.setState(
        {
          alertStatus,
          alertText
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: ""
            });
          }, 5000);
        }
      );
    });
  };

  onChangeMobileNumberHandler = (status) => {
    const alertText =
      status === "success"
        ? "pages.editNumberPopup.mobileChangeSuccessMsg"
        : "pages.editNumberPopup.mobileChangeErrorMsg";
    if (status === "success") {
      const { getUpdatedMobileNumber } = this.props;
      getUpdatedMobileNumber();
    }
    this.setState(
      {
        addNumberPopup: false,
        alertStatus: status,
        alertText
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: ""
          });
        }, 5000);
      }
    );
  };

  savePreferences = (e) => {
    e.preventDefault();
    const { preferences } = this.state;
    let { userId } = this.props;
    const { preferredLanguage } = preferences;
    const preferencePayload = { ...preferences };
    preferencePayload.preferredLanguage =
      preferredLanguage === "en_US" ? "en" : preferredLanguage;
    const payload = [
        {
          operation: "add",
          field: "/preferences/bos",
          value: preferencePayload.bos
        }
    ];
    http(
      {
        url: `managed/user/${userId}`,
        method: "PATCH",
        data: payload
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      let alertText = "";
      let alertStatus = "";
      if (res && res.status === 200 && res.data && res.data._id === userId) {
        alertText = "pages.changePreferredLang.preferenceChangeSuccessMsg";
        alertStatus = "success";
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        alertText = "pages.changePreferredLang.preferenceChangeErrorMsg";
        alertStatus = "error";
      }
      this.setState(
        {
          alertStatus,
          alertText
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: ""
            });
          }, 5000);
        }
      );
    });
  };

  render() {
    const { t, userData } = this.props;
    const {
      toggleCommunications,
      preferences,
      alertText,
      alertStatus,
      changeLanguagePopup,
      addNumberPopup,
      showAppPreferences,
      hideSection
    } = this.state;
    const { bos, preferredLanguage } = preferences;

    const availableApps = Object.keys(preferences).filter(
      (appName) => appName !== "preferredLanguage"
    );

    const { telephoneNumber } = userData;

    return (
      <>
        {changeLanguagePopup && (
          <ChangeLanguagePopup
            onClose={() => this.toggleLanguagePopup(false)}
            selectedLanguage={preferredLanguage}
            availableLanguages={["en_US", "es"]}
            onLanguageChange={this.onLanguageChange}
          />
        )}
        {addNumberPopup && (
          <ChangeMobileNumberPopup
            onClose={() => this.toggleAddNumberPopup(false)}
            onChangeMobileNumberHandler={this.onChangeMobileNumberHandler}
            telephoneNumber={telephoneNumber}
          />
        )}
        {alertText && (
          <Alert
            alertText={alertText}
            className={alertStatus}
            onAlertClose={() => {
              this.setState({
                alertText: ""
              });
            }}
          />
        )}
        <div className="section-entry">
          <h2 className="page-heading">{t("pages.profile.preferences")}</h2>
          <p className="page-desc">{t("pages.profile.preferencesDesc")}</p>

          <Row noGutters className="cards">
            <Col>
              <h3 className="cards__title">
                {t("pages.profile.manageNotifications")}
              </h3>
              {showAppPreferences &&
                  availableApps.length > 0 &&
                  !telephoneNumber && (<p className="cards__desc cards__desclink">
                      {t("pages.profile.smsNotifications")}{" "}
                      <span
                        role="button"
                        tabIndex={0}
                        onClick={() => this.toggleAddNumberPopup(true)}
                        onKeyPress={() => this.toggleAddNumberPopup(true)}
                      >
                        {t("pages.profile.addNumber")}
                      </span>    
              </p>)}
            </Col>
          </Row>

          <Row noGutters className="cards">
            <Col>
              <div className="cards__box">
                <Row noGutters className="cards__box-row globe-icon">
                  <Col lg={{ span: 5 }}>
                    <p className="cards__box-row-title">
                      {t("pages.profile.language")}
                    </p>
                  </Col>
                  <Col lg={{ span: 4 }}>
                    <p className="cards__box-row-text">
                      {t(
                        `pages.changePreferredLang.languages.${preferredLanguage}`
                      )}
                    </p>
                  </Col>
                  <Col lg={{ span: 3 }}>
                    <p
                      className="cards__box-row-link"
                      role="button"
                      tabIndex={0}
                      onClick={() => this.toggleLanguagePopup(true)}
                      onKeyPress={() => this.toggleLanguagePopup(true)}
                      aria-label={t("pages.profile.ariaChangeLanguage")}
                    >
                      {t("pages.profile.changeLanguage")}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          {showAppPreferences && availableApps.length > 0 && availableApps.includes('bos') && (
            <>
              <Row noGutters>
                <Col>
                  <div className="accordian_card">
                    <Accordion defaultActiveKey="0">
                      <Card className={`${toggleCommunications ? "open" : ""}`}>
                        {/* <Accordion.Toggle
                          as={Card.Header}
                          // eventKey="0"
                          // onClick={() => {
                          //   this.setState({
                          //     toggleCommunications: !toggleCommunications
                          //   });
                          // }}
                        >
                          {t("pages.profile.businessRelated")}
                        </Accordion.Toggle> */}
                        <div className="card-header">{t("pages.profile.businessRelated")}</div>
                        <Accordion.Collapse eventKey="0">
                          <Card.Body>
                            {!hideSection && (
                              <Row noGutters className="accordian_card__row">
                                <Col lg={{ span: 6 }}>
                                  <p className="accordian_card__row-title">
                                    {t("pages.profile.allowAllNotifications")}
                                  </p>
                                </Col>
                                <Col
                                  lg={{ span: 4 }}
                                  className="email-checkbox"
                                >
                                  <Checkbox
                                    name="notificationsEmail"
                                    ariaLabel="Email"
                                    label="pages.profile.email"
                                    isChecked={this.isAllPreferenceSelected(
                                      "bos",
                                      "email"
                                    )}
                                    handleChange={(checked) =>
                                      this.changeAllPreference(
                                        "bos",
                                        "email",
                                        checked
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={{ span: 2 }}>
                                  <Checkbox
                                    name="notificationsSms"
                                    ariaLabel="sms"
                                    label="pages.profile.sms"
                                    disabled={!telephoneNumber}
                                    isChecked={this.isAllPreferenceSelected(
                                      "bos",
                                      "sms"
                                    )}
                                    handleChange={(checked) =>
                                      this.changeAllPreference(
                                        "bos",
                                        "sms",
                                        checked
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            )}
                            <Row noGutters className="accordian_card__row">
                              <Col lg={{ span: 6 }}>
                                <p className="accordian_card__row-title">
                                  {t("pages.profile.dueDateReminders")}
                                </p>
                                <p className="accordian_card__row-desc">
                                  {t("pages.profile.receiveImportantReminders")}
                                </p>
                              </Col>
                              <Col lg={{ span: 4 }} className="email-checkbox">
                                <Checkbox
                                  name="dueDateEmail"
                                  ariaLabel="Email"
                                  label="pages.profile.email"
                                  isChecked={bos.dueDate && bos.dueDate.email}
                                  handleChange={() =>
                                    this.changePreference(
                                      "bos",
                                      "dueDate",
                                      "email"
                                    )
                                  }
                                />
                              </Col>
                              <Col lg={{ span: 2 }}>
                                <Checkbox
                                  name="dueDateSms"
                                  ariaLabel="sms"
                                  label="pages.profile.sms"
                                 isChecked={bos.dueDate && bos.dueDate.sms}
                                  disabled={!telephoneNumber}
                                  handleChange={() =>
                                    this.changePreference(
                                      "bos",
                                      "dueDate",
                                      "sms"
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                            <Row noGutters className="accordian_card__row">
                              <Col lg={{ span: 6 }}>
                                <p className="accordian_card__row-title">
                                  {t("pages.profile.resourceNotifications")}
                                </p>
                                <p className="accordian_card__row-desc">
                                  {t("pages.profile.receiveResourceImportantReminders")}
                                </p>
                              </Col>
                              <Col lg={{ span: 4 }} className="email-checkbox">
                                <Checkbox
                                  name="resourceNotificationEmail"
                                  ariaLabel="Email"
                                  label="pages.profile.email"
                                  isChecked={bos.resourceNotification && bos.resourceNotification.email}
                                  handleChange={() =>
                                    this.changePreference(
                                      "bos",
                                      "resourceNotification",
                                      "email"
                                    )
                                  }
                                />
                              </Col>
                              <Col lg={{ span: 2 }}>
                                <Checkbox
                                  name="resourceNotificationSms"
                                  ariaLabel="sms"
                                  label="pages.profile.sms"
                                 isChecked={bos.resourceNotification && bos.resourceNotification.sms}
                                  disabled={!telephoneNumber}
                                  handleChange={() =>
                                    this.changePreference(
                                      "bos",
                                      "resourceNotification",
                                      "sms"
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                            {!hideSection && (
                              <>
                                <Row noGutters className="accordian_card__row">
                                  <Col lg={{ span: 6 }}>
                                    <p className="accordian_card__row-title">
                                      {t("pages.profile.newsAndUpdates")}
                                    </p>
                                    <p className="accordian_card__row-desc">
                                      {t("pages.profile.newsAndUpdatesDesc")}
                                    </p>
                                  </Col>
                                  <Col
                                    lg={{ span: 4 }}
                                    className="email-checkbox"
                                  >
                                    <Checkbox
                                      name="newsAndUpdatesEmail"
                                      ariaLabel="Email"
                                      label="pages.profile.email"
                                      isChecked={bos.news && bos.news.email}
                                      handleChange={() =>
                                        this.changePreference(
                                          "bos",
                                          "news",
                                          "email"
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col lg={{ span: 2 }}>
                                    <Checkbox
                                      name="newsAndUpdatesSms"
                                      ariaLabel="sms"
                                      label="pages.profile.sms"
                                      isChecked={bos.news && bos.news.sms}
                                      disabled={!telephoneNumber}
                                      handleChange={() =>
                                        this.changePreference(
                                          "bos",
                                          "news",
                                          "sms"
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                                <Row noGutters className="accordian_card__row">
                                  <Col lg={{ span: 6 }}>
                                    <p className="accordian_card__row-title">
                                      {t("pages.profile.covidRelatedReminders")}
                                    </p>
                                    <p className="accordian_card__row-desc">
                                      {t("pages.profile.stayUpDateWithChanges")}
                                    </p>
                                  </Col>
                                  <Col
                                    lg={{ span: 4 }}
                                    className="email-checkbox"
                                  >
                                    <Checkbox
                                      name="covidRelatedReminderEmail"
                                      ariaLabel="Email"
                                      label="pages.profile.email"
                                      isChecked={
                                        bos.covid19 && bos.covid19.email
                                      }
                                      handleChange={() =>
                                        this.changePreference(
                                          "bos",
                                          "covid19",
                                          "email"
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col lg={{ span: 2 }}>
                                    <Checkbox
                                      name="covidRelatedReminderSms"
                                      ariaLabel="sms"
                                      label="pages.profile.sms"
                                      isChecked={bos.covid19 && bos.covid19.sms}
                                      disabled={!telephoneNumber}
                                      handleChange={() =>
                                        this.changePreference(
                                          "bos",
                                          "covid19",
                                          "sms"
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div>
                </Col>
              </Row>
              <Row noGutters>
                <Col lg={{ span: 3, offset: 9 }} className="submit-btn">
                  <Button
                    size="lg"
                    variant="primary"
                    block
                    type="submit"
                    onClick={(e) => this.savePreferences(e)}
                  >
                    {t("pages.profile.save")}
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </div>
      </>
    );
  }
}

Preferences.propTypes = {
  t: PropTypes.func.isRequired,
  userId: PropTypes.string,
  userData: PropTypes.object,
  getUpdatedMobileNumber: PropTypes.func.isRequired
};

Preferences.defaultProps = {
  userId: "",
  userData: {
    userName: "",
    mail: "",
    telephoneNumber: "",
    givenName: "",
    sn: "",
    emailValidated: false,
    phoneValidated: false
  }
};

export default withTranslation()(Preferences);
